function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M243.5,74.6622568 C245.84721,74.6622568 247.97221,75.6136517 249.510408,77.1518492 C251.048605,78.6900466 252,80.8150466 252,83.1622568 L252,83.1622568 L252,174.964686 L254.235931,177.395045 C254.375871,177.547154 254.464508,177.73802 254.491355,177.940836 L254.491355,177.940836 L254.5,215.252412 C254.5,215.459637 254.435671,215.660616 254.317528,215.828314 L254.317528,215.828314 L252,218.362385 L252,228.162257 C252,230.509467 251.048605,232.634467 249.510408,234.172664 C247.97221,235.710862 245.84721,236.662257 243.5,236.662257 L243.5,236.662257 L3.5,236.662257 C1.15278981,236.662257 -0.972210187,235.710862 -2.51040764,234.172664 C-4.04860509,232.634467 -5,230.509467 -5,228.162257 L-5,228.162257 L-5,218.359828 L-7.23593101,215.929468 C-7.40574743,215.744885 -7.5,215.503227 -7.5,215.252412 L-7.5,215.252412 L-7.5,178.072102 C-7.5,177.821286 -7.40574743,177.579628 -7.23593101,177.395045 L-7.23593101,177.395045 L-5,174.964686 L-5,83.1622568 C-5,80.8150466 -4.04860509,78.6900466 -2.51040764,77.1518492 C-0.972210187,75.6136517 1.15278981,74.6622568 3.5,74.6622568 L3.5,74.6622568 Z",
  id: "Combined-Shape",
  stroke: "#000000",
  strokeWidth: 3,
  fill: "#000000",
  opacity: 0.756603423,
  transform: "translate(123.500000, 155.662257) rotate(75.000000) translate(-123.500000, -155.662257) "
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(114.500000, 149.500000) rotate(75.000000) translate(-114.500000, -149.500000) translate(-18.000000, 67.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M252.5,1.5 C254.84721,1.5 256.97221,2.45139491 258.510408,3.98959236 C260.048605,5.52778981 261,7.65278981 261,10 L261,10 L261,101.802429 L263.235931,104.232789 C263.375871,104.384898 263.464508,104.575763 263.491355,104.778579 L263.491355,104.778579 L263.5,142.090155 C263.5,142.29738 263.435671,142.49836 263.317528,142.666057 L263.317528,142.666057 L261,145.200129 L261,155 C261,157.34721 260.048605,159.47221 258.510408,161.010408 C256.97221,162.548605 254.84721,163.5 252.5,163.5 L252.5,163.5 L12.5,163.5 C10.1527898,163.5 8.02778981,162.548605 6.48959236,161.010408 C4.95139491,159.47221 4,157.34721 4,155 L4,155 L4,145.197571 L1.76406899,142.767211 C1.59425257,142.582628 1.5,142.340971 1.5,142.090155 L1.5,142.090155 L1.5,104.909845 C1.5,104.659029 1.59425257,104.417372 1.76406899,104.232789 L1.76406899,104.232789 L4,101.802429 L4,10 C4,7.65278981 4.95139491,5.52778981 6.48959236,3.98959236 C8.02778981,2.45139491 10.1527898,1.5 12.5,1.5 L12.5,1.5 Z",
  id: "Combined-Shape",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  fill: "#262626"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#000000",
  strokeWidth: 30,
  cx: 76,
  cy: 77,
  r: 30
}), /*#__PURE__*/React.createElement("line", {
  x1: 31.5,
  y1: 77,
  x2: 17.75,
  y2: 149.25,
  id: "Line",
  stroke: "#000000",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.75,
  y1: 155.75,
  x2: 69.75,
  y2: 158.25,
  id: "Line-2",
  stroke: "#000000",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 195.75,
  y1: 158.25,
  x2: 239.75,
  y2: 155.75,
  id: "Line-4",
  stroke: "#000000",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 247.75,
  y1: 147.25,
  x2: 223,
  y2: 77,
  id: "Line-5",
  stroke: "#000000",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.096118,126 C212.013853,126 212.872704,126.312297 213.557767,126.847178 C214.24283,127.382059 214.754104,128.139523 214.976688,129.029857 L214.976688,129.029857 L222.476688,159.029857 C222.744585,160.101447 222.552773,161.180177 222.02609,162.057983 C221.499406,162.935789 220.63785,163.612673 219.56626,163.88057 C219.248978,163.959891 218.923165,164 218.596118,164 L218.596118,164 L46.403882,164 C45.2993125,164 44.2993125,163.552285 43.5754549,162.828427 C42.8515973,162.104569 42.403882,161.104569 42.403882,160 C42.403882,159.672953 42.4439914,159.34714 42.523312,159.029857 L42.523312,159.029857 L50.023312,129.029857 C50.2458955,128.139523 50.7571704,127.382059 51.4422332,126.847178 C52.127296,126.312297 52.9861467,126 53.903882,126 L53.903882,126 Z",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  opacity: 0.485677083
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.5,14.5 C248.604569,14.5 249.604569,14.9477153 250.328427,15.6715729 C251.052285,16.3954305 251.5,17.3954305 251.5,18.5 L251.5,18.5 L251.5,116 C251.5,116.414214 251.332107,116.789214 251.06066,117.06066 C250.789214,117.332107 250.414214,117.5 250,117.5 L250,117.5 L15,117.5 C14.5857864,117.5 14.2107864,117.332107 13.9393398,117.06066 C13.6678932,116.789214 13.5,116.414214 13.5,116 L13.5,116 L13.5,18.5 C13.5,17.3954305 13.9477153,16.3954305 14.6715729,15.6715729 C15.3954305,14.9477153 16.3954305,14.5 17.5,14.5 L17.5,14.5 Z",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  opacity: 0.503580729
}), /*#__PURE__*/React.createElement("line", {
  x1: 73.25,
  y1: 158.25,
  x2: 195.75,
  y2: 158.25,
  id: "Line-3",
  stroke: "#000000",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#000000",
  strokeWidth: 20,
  cx: 189,
  cy: 77,
  r: 25
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  opacity: 0.637393043,
  cx: 76,
  cy: 77,
  r: 14.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  opacity: 0.543782552,
  x: 57,
  y: 59,
  width: 151,
  height: 36,
  rx: 17.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  cx: 239.5,
  cy: 148.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  opacity: 0.637393043,
  cx: 189,
  cy: 77,
  r: 14
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  cx: 69.5,
  cy: 152.5,
  r: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  x: 88.5,
  y: 143,
  width: 12,
  height: 12,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  x: 164.5,
  y: 143,
  width: 12,
  height: 12,
  rx: 5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  cx: 25.5,
  cy: 148.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  cx: 195.5,
  cy: 152.5,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#D8D8D8",
  opacity: 0.495256696,
  cx: 11.5,
  cy: 8,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#D8D8D8",
  opacity: 0.495256696,
  cx: 254.5,
  cy: 8,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#D8D8D8",
  opacity: 0.495256696,
  cx: 11.5,
  cy: 157,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#D8D8D8",
  opacity: 0.495256696,
  cx: 132.5,
  cy: 133,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#D8D8D8",
  opacity: 0.495256696,
  cx: 254.5,
  cy: 157,
  r: 3
}))));

var SvgTape = function SvgTape(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "238px",
    height: "306px",
    viewBox: "0 0 238 306",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tape.3a0b391e.svg";
export { ForwardRef as ReactComponent };